import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const RejectReason = props => (
  <div className={Styles['reject-reason']}>
    <div className={Styles.title}>Rejected Reason : </div>
    <div>{props.data.rejectReason}</div>
  </div>
)

RejectReason.propTypes = {
  data: PropTypes.shape({
    rejectReason: PropTypes.string.isRequired,
  }).isRequired,
}

export default RejectReason
